import MScroll from './src/scroll'

export default MScroll
